<template>
    <!-- PODCAST INFO -->
    <div class="explorer-section" :id="segmentId">
        <div class="segment-header-container explorer p-0" id="podcast-header">
            <!--            <div class="segment-header">-->
            <!--                <div class="segment-header-headline simple">Voices of Enoch Podcast</div>-->
            <!--            </div>-->
            <div class="segment-header-visual voices">
                <div class="content">
                    <svg viewBox="0 0 324 135" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M318.712 107.339V96.0791H308.963V107.339H304.22V81.0818H308.963V91.5815H318.712V81.0818H323.456V107.339H318.712ZM286.627 103.493H292.977L296.152 100.37L299.439 103.604L295.499 107.525H284.031L279.866 103.381V84.9665L284.031 80.8224H295.162L298.711 84.7064L295.424 87.9545L292.603 84.8553H286.627L284.61 86.8615V101.765L286.627 103.493ZM257.68 107.525L253.515 103.381V84.9665L257.68 80.8224H269.185L273.368 84.9665V103.381L269.185 107.525H257.68ZM268.624 86.8615L266.589 84.8553H260.276L258.674 86.8615V101.765L260.276 103.493H266.589L268.624 101.765V86.8615ZM232.992 91.2027L231.871 87.9545H231.628V107.339H227.351V81.0818H233.626L241.246 97.4904L242.086 100.724H242.348V81.0818H246.625V107.339H240.35L232.992 91.2027ZM204.493 81.0818H221.058V85.041H209.236V92.0086H219.825V95.8925H209.236V103.307H221.058V107.339H204.493V81.0818ZM191.906 85.041H180.234V92.9193H190.636V96.9513H180.234V107.339H175.49V81.0818H191.906V85.041ZM152.93 107.525L148.765 103.381V84.9665L152.93 80.8224H164.434L168.965 84.9665V103.381L164.434 107.525H152.93ZM163.874 86.8615L161.838 84.8553H155.526L153.509 86.8615V101.765L155.526 103.493H161.838L163.874 101.765V86.8615ZM94.0274 81.0818H110.593V85.041H98.7715V92.0086H109.361V95.8925H98.7715V103.307H110.593V107.339H94.0274V81.0818ZM76.4352 103.493H82.7853L85.9603 100.37L89.2472 103.604L85.3066 107.525H73.8399L69.6748 103.381V84.9665L73.8399 80.8224H84.9702L88.5186 84.7064L85.2318 87.9545L82.412 84.8553H76.4352L74.4189 86.8615V101.765L76.4352 103.493ZM51.1862 103.307H55.2387V85.041H51.1862V81.0818H64.129V85.041H59.9828V103.307H64.129V107.339H51.1862V103.307ZM29.9708 107.525L25.8065 103.381V84.9665L29.9708 80.8224H41.4753L45.6585 84.9665V103.381L41.4753 107.525H29.9708ZM40.9153 86.8615L38.8792 84.8553H32.5669L30.5498 86.8615V101.765L32.5669 103.493H38.8792L40.9153 101.765V86.8615ZM8.06465 107.339L0.370056 81.0818H5.6552L10.6229 99.423L11.2767 102.619H11.7676L12.2668 99.423L17.0108 81.0818H21.7919L14.6014 107.339H8.06465ZM121.294 103.567H128.975L130.277 101.671V98.0108L128.975 96.1151H119.949L115.747 91.9342V84.9665L119.912 80.8224H130.857L134.405 84.7064L131.192 87.4751L128.975 84.7808H122.396L120.491 86.6757V90.2438L122.396 92.1575H131.426L135.021 96.3385V103.381L130.857 107.525H118.885L115.538 103.845L118.343 100.761L121.294 103.567Z"
                              fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M193.543 63.2839C192.588 63.2839 191.744 62.9403 190.87 62.8364C189.265 60.7786 189.359 58.2922 190.635 56.6967C203.309 42.9971 203.309 20.7205 190.635 7.02246C189.359 5.427 189.265 2.94055 190.87 1.47273C192.936 0.572731 194.981 0.101458 196.454 2.29909C211.835 18.3232 211.835 45.3944 196.453 62.0157C195.673 62.8593 194.608 63.2839 193.543 63.2839ZM180.373 50.0441C179.447 50.0441 179.162 49.5745 177.767 49.0672C176.129 47.6354 175.967 45.1555 177.407 43.524C183.16 37.0096 183.16 26.4166 177.407 19.9064C175.966 18.2757 176.129 15.795 177.767 14.3624C179.412 13.0696 181.896 13.2333 183.344 14.715C191.793 24.093 191.793 39.9355 183.344 48.7096C183.134 49.5941 181.471 50.0441 180.373 50.0441ZM160.609 38.4055C156.974 38.4055 154.026 35.1802 154.026 31.7119C154.026 28.2436 156.972 25.3121 160.609 25.3121C164.245 25.3121 167.193 28.5382 167.193 32.0065C167.193 35.4747 164.245 38.4055 160.609 38.4055ZM143.812 43.6786C145.253 45.3093 145.091 47.79 143.452 49.2226C142.702 49.8772 141.77 50.1995 140.846 50.1995C139.749 50.1995 138.655 49.7495 137.875 48.8643C129.596 39.4863 129.596 24.2403 137.875 14.8696C139.323 13.2333 141.823 13.0696 143.452 14.3624C145.097 15.9341 145.261 18.4214 143.812 20.061C138.059 26.5754 138.059 37.1684 143.812 43.6786ZM130.354 62.82C129.596 62.9411 128.637 63.2839 127.68 63.2839C126.613 63.2839 125.549 62.8585 124.773 62.0165C109.568 45.3878 109.568 18.3322 124.773 2.30728C126.255 0.103094 128.757 0.572731 130.357 1.47355C131.954 2.94137 132.069 5.42619 130.588 7.02164C117.915 20.7205 117.915 42.9979 130.588 56.6951C132.065 58.2914 131.96 60.7778 130.354 62.82Z"
                              fill="#DBAA43"/>
                        <path
                            d="M51.2372 132.134L48.2752 135H40.9489L38 132.134V119.866L40.9489 117H48.2752L51.2372 119.866V132.134ZM40.5164 120.885V131.115L42.2071 132.758H47.017L48.7077 131.115V120.885L47.017 119.242H42.2071L40.5164 120.885Z"
                            fill="white"/>
                        <path
                            d="M68.5503 117V132.134L65.6014 135H58.6159L55.667 132.134V117H58.1965V131.115L59.8872 132.758H64.5005L66.1912 131.115V117H68.5503Z"
                            fill="white"/>
                        <path d="M84.3169 119.242H78.9827V135H76.4533V119.242H71.106V117H84.3169V119.242Z" fill="white"/>
                        <path
                            d="M97.0036 135L92.849 127.981H89.389V135H86.8595V117H95.693L98.6419 119.866V124.962L95.6668 127.854L99.9001 135H97.0036ZM94.4348 119.242H89.389V125.739H94.4348L96.1255 124.096V120.885L94.4348 119.242Z"
                            fill="white"/>
                        <path d="M102.036 119.242V117H110.503V119.242H107.515V132.758H110.503V135H102.036V132.758H104.998V119.242H102.036Z"
                              fill="white"/>
                        <path
                            d="M127.187 132.134L124.238 135H114.12V117H124.238L127.187 119.866V132.134ZM116.65 119.242V132.758H122.98L124.671 131.115V120.885L122.98 119.242H116.65Z"
                            fill="white"/>
                        <path d="M134.159 126.936V132.758H142.77V135H131.63V117H142.77V119.242H134.159V124.694H141.905V126.936H134.159Z"
                              fill="white"/>
                        <path
                            d="M156.794 135L152.639 127.981H149.179V135H146.65V117H155.483L158.432 119.866V124.962L155.457 127.854L159.69 135H156.794ZM154.225 119.242H149.179V125.739H154.225L155.916 124.096V120.885L154.225 119.242Z"
                            fill="white"/>
                        <path
                            d="M164.461 120.885V123.178L166.151 124.822H171.892L174.854 127.701V132.134L171.892 135H164.303L161.564 132.389L163.334 130.669L165.562 132.758H170.634L172.324 131.115V128.707L170.634 127.064H164.893L161.944 124.197V119.866L164.893 117H171.787L174.29 119.395L172.521 121.115L170.529 119.242H166.151L164.461 120.885Z"
                            fill="white"/>
                        <path
                            d="M186.243 135H183.714V117H192.809L195.771 119.866V126.019L192.809 128.898H187.318L186.243 128.108V135ZM191.551 119.242H186.243V126.656H191.551L193.242 125.013V120.885L191.551 119.242Z"
                            fill="white"/>
                        <path
                            d="M212.757 132.134L209.795 135H202.468L199.519 132.134V119.866L202.468 117H209.795L212.757 119.866V132.134ZM202.036 120.885V131.115L203.727 132.758H208.536L210.227 131.115V120.885L208.536 119.242H203.727L202.036 120.885Z"
                            fill="white"/>
                        <path
                            d="M230.253 132.134L227.304 135H217.186V117H227.304L230.253 119.866V132.134ZM219.716 119.242V132.758H226.046L227.737 131.115V120.885L226.046 119.242H219.716Z"
                            fill="white"/>
                        <path
                            d="M237.082 120.885V131.115L238.772 132.758H243.582L245.81 130.669L247.58 132.389L244.84 135H237.514L234.565 132.134V119.866L237.514 117H244.526L247.095 119.471L245.325 121.204L243.255 119.242H238.772L237.082 120.885Z"
                            fill="white"/>
                        <path
                            d="M259.834 135L258.418 130.592H252.219L250.843 135H248.379L254.015 117H256.675L262.494 135H259.834ZM254.853 122.083L252.914 128.35H257.697L255.679 122.083L255.325 120.134H255.194L254.853 122.083Z"
                            fill="white"/>
                        <path
                            d="M266.478 120.885V123.178L268.169 124.822H273.91L276.872 127.701V132.134L273.91 135H266.321L263.582 132.389L265.351 130.669L267.579 132.758H272.651L274.342 131.115V128.707L272.651 127.064H266.911L263.962 124.197V119.866L266.911 117H273.805L276.308 119.395L274.539 121.115L272.547 119.242H268.169L266.478 120.885Z"
                            fill="white"/>
                        <path d="M291 119.242H285.666V135H283.136V119.242H277.789V117H291V119.242Z" fill="white"/>
                    </svg>


                </div>
            </div>
        </div>
        <div class="explorer-sectionals p-0">
            <overlay-scrollbars :options="{ className: 'os-theme-light', scrollbars: { autoHide: 'scroll' } }">
                <div class="explorer-scrollable">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="podcast-headline mb-sm-3">
                                <div class="podcast-section-title">Hosts</div>
                                <div class="explorer-sets-pattern m-0">
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                </div>
                            </div>
                            <div class="podcast-hosts mb-2">
                                <div class="podcast-host">
                                    <a href="https://www.twitch.tv/maffeine" target="_blank" class="podcast-host-visual mb-2"
                                       style="background-image: url('https://outriders-outpost.s3.us-west-1.amazonaws.com/assets/maffeine.jpg')"></a>
                                    <div class="podcast-host-text mb-1">Maffeine</div>
                                    <div class="podcast-host-description twitch"><a href="https://www.twitch.tv/maffeine" target="_blank"><i
                                        class="fab fa-twitch twitch"></i>&nbsp;&nbsp;Maffeine</a></div>
                                </div>
                                <div class="podcast-host">
                                    <a href="https://www.twitch.tv/PlayDohBear" target="_blank" class="podcast-host-visual mb-2"
                                       style="background-image: url('https://outriders-outpost.s3.us-west-1.amazonaws.com/assets/playdohbear.jpg')"></a>
                                    <div class="podcast-host-text mb-1">PlayDohBear</div>
                                    <div class="podcast-host-description twitch"><a href="https://www.twitch.tv/maffeine" target="_blank"><i
                                        class="fab fa-twitch twitch"></i>&nbsp;&nbsp;PlayDohBear</a></div>
                                </div>
                                <div class="podcast-host">
                                    <a href="https://www.twitch.tv/capo167" target="_blank" class="podcast-host-visual mb-2"
                                       style="background-image: url('https://outriders-outpost.s3.us-west-1.amazonaws.com/assets/capo.jpg')"></a>
                                    <div class="podcast-host-text mb-1">Capo167</div>
                                    <div class="podcast-host-description twitch"><a href="https://www.twitch.tv/maffeine" target="_blank"><i
                                        class="fab fa-twitch twitch"></i>&nbsp;&nbsp;Capo167</a></div>
                                </div>
                                <div class="podcast-host">
                                    <a href="https://www.twitch.tv/dudewithablunt" target="_blank" class="podcast-host-visual mb-2"
                                       style="background-image: url('https://outriders-outpost.s3.us-west-1.amazonaws.com/assets/bigdaddy.jpg')"></a>
                                    <div class="podcast-host-text mb-1">dudewithablunt</div>
                                    <div class="podcast-host-description twitch"><a href="https://www.twitch.tv/dudewithablunt" target="_blank"><i
                                        class="fab fa-twitch twitch"></i>&nbsp;&nbsp;dudewithablunt</a></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <p>
                                Brought to you by content creators and community members who have invested extraordinary amount of time with the game
                                and
                                helping others conquer the hardest end-game content in Outriders.
                            </p>
                            <p>Voices of Enoch is about analyzing
                                the state of the game and latest changes and how they affect it, helping newer Outriders understand the synergy
                                of mods and skills in order to maximize the efficiency in completing harder content and deep-diving into each one of
                                the
                                classes and their positives and negatives.</p>
                            <p>If you are new or seasoned Outrider, Voices of Enoch provides valuable entertainment and insight into the game.</p>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 col-md-6">
                            <div class="podcast-headline mb-sm-2">
                                <div class="podcast-section-title">Episodes</div>
                                <div class="explorer-sets-pattern m-0">
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                    <div class="slant"></div>
                                </div>
                            </div>
                            <div class="podcast-episodes-description mb-3">
                                Catch up on episodes of <strong>Voices of Enoch</strong> and listen to the recorded broadcasts. You can listen/watch
                                to
                                podcast live usually on Thursdays or Fridays (schedule is determined each week) by viewing hosts's Twitch channels.
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 11</div>
                                <div class="podcast-episode-description">New Worldslayer DLC announced for 2022 and the upcoming New Horizon update coming tomorrow (Nov. 16).
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode11.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 10</div>
                                <div class="podcast-episode-description">Outriders Recap + New Horizon DLC Soon?
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode10.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 09</div>
                                <div class="podcast-episode-description">The crew discusses patch changes including Devastator Impale skill change, borrowed time revive bug fix, performance improvements including crawler fix and other Outriders related notes.
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode09.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 08</div>
                                <div class="podcast-episode-description">Discussing everything Outriders and latest news and updates from September 23rd patch notes including mentioned Fortress changes.
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode08.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 07</div>
                                <div class="podcast-episode-description">Discussing everything Outriders and latest news and updates.
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode07.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 06</div>
                                <div class="podcast-episode-description">Discussing the latest buffs to the mod done by PCF on the server and
                                    suggestions on how to make a more balanced end-game. Guest: NickTew
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode06.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 05</div>
                                <div class="podcast-episode-description">The team talks about the updates and state of the game, the new Outriders
                                    app, touch up on and provide insight about common community questions and struggles newer players face and more.
                                    Guest: Bozzified
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode05.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 04</div>
                                <div class="podcast-episode-description">Developers News, PCF controversy with Square Enix and royalties, "New
                                    Horizon" possible name of the DLC.
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode04.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 03</div>
                                <div class="podcast-episode-description">Outriders gets a long awaited update. In this podcast the crew discusses how
                                    the changes and updates affected the builds for classes and people playing the game.
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode03.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 02</div>
                                <div class="podcast-episode-description">In this episode, a fiery debate on the quality of updates Outriders The Game
                                    is getting and discussion on how to improve it . Guest: Tom_TomTV
                                </div>
                                <div class="podcast-audio">
                                    <audio controls>
                                        <source src="https://outriders-outpost.s3.us-west-1.amazonaws.com/podcast/voices-of-enoch-episode02.mp3"
                                                type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                            <div class="podcast-episode">
                                <div class="podcast-episode-title">Episode 01</div>
                                <div class="podcast-episode-description">First episode of the podcast. A spur of them moment, longer episodes touching
                                    up on Outriders state of affairs prior to the major patches.
                                </div>
                                <div class="podcast-audio">
                                    Audio currently unavailable.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </overlay-scrollbars>
        </div>
    </div>
</template>
<style>

</style>
<script>

import store from '../store'
import eventBus from "../eventBus";
import setsData from '../weapons.json';
import weaponTypes from "../weapon-types.json";
import variants from "../variants.json";
import mods from "../mods.json";
import weaponAttributes from "../attributes.json";
import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue';


export default {
    components: {
        'overlay-scrollbars': OverlayScrollbarsComponent
    },
    props: ['segmentId'],
    directives: {
        // directive definition
    },
    data: function () {
        return {}
    },
    computed: {},
    watch: {},
    created() {
    },
    beforeUpdate() {
    },
    updated() {
    },
    mounted() {
        // console.log('Podcast component mounted.')
    },
    methods: {}
}
</script>
